<template>
    <v-app>
        <div class="divPorfesor">
            <div class="divResumenInfo">
                <v-avatar class="hidden-sm-and-down" width="200" height="200">
                    <img :src="img" alt="Nava">
                </v-avatar>
                <v-img class="hidden-md-and-up" :src="img" alt="Nava"></v-img>
                <br>
                <br>
                <span class="title">
                    <strong>Ph. D. Urbano Nava Camberos</strong>
                </span>
                <hr>
                <br>
                <div class="text-left">
                    <div>
                        <p>
                            <v-icon color="red">mdi-email-open</v-icon> amador.antonino@hotmail.com
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div class="divSNI">
                        <v-icon color="green">mdi-checkbox-marked-circle</v-icon>
                        <b>SNI</b>
                        <v-spacer></v-spacer>
                        <b>NIVEL: </b> 1
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <p>
                            <v-icon color="red">mdi-alpha-x-circle</v-icon>
                            <b>PROMEP</b>
                        </p>
                    </div>
                    <v-divider></v-divider>
                    <div>
                        <b>CUERPO ACADEMICO:</b>
                        <br>
                        <br>
                        <p></p>
                    </div>
                </div>
                <br>
                <div>
                    <v-btn color="blue" text @click="insertarRuta('/conocenos/planta-academica/')">Regresar</v-btn>
                </div>
            </div>
            <div class="divEstudiosInfo" v-show="info">
                <div id="divAgrupaInfo">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>FORMACIÓN ACADEMICA</strong>
                        </span>
                    </div>
                    <div id="licenciatura">
                        <p>
                            <b>LICENCIATURA.</b>
                            <br>
                            INGENIERO (1980)
                            <br>
                            <v-divider class="m-0"></v-divider>
                            UNIVERSIDAD AUTONOMA DE CHAPINGO
                        </p>
                        <br>
                        <p>
                            <b>MAESTRIA.</b>
                            <br>
                        <ul>
                            <li>(1986)</li>
                            <p>
                                COLEGIO DE POSTGRADUADOS.
                            </p>
                        </ul>
                        </p>
                        <br>
                        <p>
                            <b>DOCTORADO.</b>
                            <br>
                        <ul>
                            <li>(1996)</li>
                            <p>
                                TEXAS A&M UNIVERSITY.
                            </p>
                        </ul>
                        </p>
                    </div>
                </div>
                <div id="divAgrupaInfo" class="mt-2">
                    <div id="estiloTitulos">
                        <span class="title">
                            <strong>ÁREA DE CONOCIMIENTO.</strong>
                        </span>
                    </div>
                    <div id="vinetaCon">
                        <ul>
                            <li>ENTOMOLOGIA / CONTROL BIOLÓGICO</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </v-app>
</template>
<script>
//import datos from `./${personaje._id}`
//const datos = await import(`./${this.datosTabla}.json`);

export default {
    data() {
        return {
            img: require('@/assets/images/Planta Academica/nava.jpg'),
            item: [],
            datos: null,
            publicaciones: false,
            info: true,
        }
    },
    methods: {
        insertarRuta(ruta) {
            this.$router.push(ruta);
        },
    },
}
</script>
